export default function normalize(user) {
  return {
    user: normalizeUser(user),
    helpee: normalizeHelpee(user),
  }
}

function normalizeUser(user) {
  if (user.profile) return user.profile
  // WARNING: If you update this object structure by adding or removing fields,
  // you need to update the localstorage key version in ./cache.js.
  // https://github.com/fs-webdev/zion/blob/master/packages/user/src/cache.js#L45
  // e.g. s4-v8ges9dif9-prod-v3-user => s4-v8ges9dif9-prod-v4-user
  return {
    cisId: user.id,
    displayName: user.displayName,
    contactName: user.contactName,
    personId: user.personId,
    gender: user.gender,
    helperPin: user.helperAccessPin,
    birthDate: user.birthdate,
    country: user.country,
    cpUserId: user.cpUserId,
    email: user.email,
    familyName: user.familyName,
    phoneNumber: user.phoneNumber,
  }
}

function normalizeHelpee(user = {}) {
  if (!user.helper && !user.proxyContact) return null
  if (user.helper) return user.helper

  // if in admin mode, return null
  if (user.proxyContact?.id?.includes('wkca')) return null

  return {
    cisId: user.proxyContact.id,
    contactName: user.proxyContact.contactName,
    cpUserId: user.proxyContact.cpUserId,
    personId: user.proxyContact.personId,
  }
}
